import { openModal } from './modal.js';

const STORAGE_KEY = 'newsletter_exit_intent_seen';
const STORAGE_TTL_DAYS = 30;

function hasSeen() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const expires = parseInt(raw, 10);
    if (Date.now() > expires) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
    }
    return true;
}

function markSeen() {
    const expires = Date.now() + STORAGE_TTL_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, String(expires));
}

function initExitIntent() {
    if (!ajax_object.newsletter_exit_intent) return;
    if (hasSeen()) return;

    const modal = document.getElementById('newsletter-modal');
    if (!modal) return;

    let triggered = false;

    function trigger() {
        if (triggered) return;
        triggered = true;
        markSeen();
        document.removeEventListener('mouseleave', onMouseLeave);
        window.removeEventListener('scroll', onScrollUp);
        openModal('newsletter-modal');
    }

    function onMouseLeave(e) {
        if (e.clientY > 20) return;
        trigger();
    }

    let lastScrollY = window.scrollY;
    let scrollDelta = 0;

    function onScrollUp() {
        const current = window.scrollY;
        const diff = lastScrollY - current;
        lastScrollY = current;

        if (diff > 0) {
            scrollDelta += diff;
            if (scrollDelta > 150 && current > 300) trigger();
        } else {
            scrollDelta = 0;
        }
    }

    document.addEventListener('mouseleave', onMouseLeave);
    window.addEventListener('scroll', onScrollUp, { passive: true });
}

export function initNewsletter() {
    document.addEventListener('DOMContentLoaded', initExitIntent);

    document.addEventListener('submit', async (e) => {
        const form = e.target.closest('.js-newsletter-form');
        if (!form) return;
        e.preventDefault();

        const btn = form.querySelector('[type="submit"]');
        const msg = form.querySelector('.newsletter-signup__message');

        btn.disabled = true;
        msg.hidden = true;

        const params = new URLSearchParams({
            action: 'newsletter_subscribe',
            nonce:  ajax_object.newsletter_nonce,
            email:  form.querySelector('[name="newsletter_email"]').value,
            name:   form.querySelector('[name="newsletter_name"]')?.value ?? '',
        });

        try {
            const res  = await fetch(ajax_object.ajax_url, { method: 'POST', body: params });
            const data = await res.json();

            msg.textContent = data.data?.message ?? '';
            msg.className   = 'newsletter-signup__message ' + (data.success ? 'is-success' : 'is-error');
            msg.hidden = false;

            if (data.success) {
                form.reset();
            }
        } catch {
            msg.textContent = 'Something went wrong. Please try again.';
            msg.className   = 'newsletter-signup__message is-error';
            msg.hidden = false;
        } finally {
            btn.disabled = false;
        }
    });
}
